import React from "react";
import { useEffect, useState, useRef } from "react";
import { Routes, Route, Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import RouteSetting from "./RouteSetting";
import MainPage from "./MainPage";
import PageSetting from "./PageSetting";
import Layout from "./components/layout_fronted";
import Management from "./Management";
import MoreContent from "./MoreContent";
import Appointment, { AppointmentManagement } from "./Appointment";
import ArticleManagement from "./views/ArticleManagement";
import PageManagement from "./views/PageManagement";
import TemplateManagement from "./TemplateManagement";
import NavBarBackend from "./../../theme/layout_backend2";
import ProtalMainPage from "./ProtalMainPage";
import Live from "../audio_recorder/views/Live";
import MainRouteNews from "../news/MainRoute";
import SystemInformationSetting from "./SystemInformationSetting";
import CommunitySetting from "./CommunitySetting";
import MenuSetting from "./views/menu_table";
import { useCRUDController } from "../controllers/CRUDController";
import BlogCategory from "./views/blog_category"
// import { QuestionAndAnswerAccordion } from "./views/question_and_answer";
import PreviewPage from './views/preview_page'
import { Mainlayout, TabsCard } from '../ui/ot'
// import ComponentLayout from '../component_layout/ComponentLayout'
import ComponentLayout from '../component_layout/afatsLayout'
import { QuestionAndAnswerAccordion } from "../question_and_answer/views/question_and_answer"
import RouteOrganizationStructure from './../organization_structure/MainRoute'
import { useStaffDivergeSelf } from "../permission_management/controllers/staff_diverge_self_controller";
import { BackgroundProvider } from "../component_layout/BackgroundContext";
import FormDownload from './views/form_download'
import HomePage from './views/home_page'
import News from './views/news'
import New from './views/new'






const MainRoute = ({ prefixTitle = "形象網站", admin = false }) => {
    const navigate = useNavigate()
    const [treeData, setTreeData] = useState([]);
    const [dynamicRoutes, setDynamicRoutes] = useState([]);
    const [firstDynamicRoute, setFirstDynamicRoute] = useState(null);
    // const backendMenuData = [
    //     {
    //         key: "/library",
    //         label: "圖書自動化系統管理後台",
    //     },
    //     {
    //         key: "/officialweb/frontend",
    //         label: "網站前台首頁",
    //     },
    //     {
    //         label: "後台管理首頁",
    //         key: "/officialweb/admin",
    //     },
    //     {
    //         label: "網站地圖與流量統計",
    //         children: [
    //             {
    //                 key: "/officialweb/admin/systemInformationSetting",
    //                 label: "基本資料設定",
    //             },
    //             {
    //                 key: "/officialweb/admin/menuSetting",
    //                 label: "選單分類設定",
    //             },
    //             // {
    //             //     key: "/officialweb/admin/seoSetting",
    //             //     label: "SEO優化設定",
    //             // },
    //             // {
    //             //     key: "/officialweb/admin/systemSecuritySetting",
    //             //     label: "系統安全性設定",
    //             // },
    //         ],
    //     },
    //     {
    //         label: "網站主題風格設定",
    //         children: [
    //             {
    //                 key: "/officialweb/admin/templateManagement",
    //                 label: "主題樣式設定",
    //             },
    //         ],
    //     },
    //     {
    //         label: "客製化頁面編排與檔案管理",
    //         children: [
    //             {
    //                 key: "/officialweb/admin/pageSetting",
    //                 label: "頁面管理",
    //             },
    //             {
    //                 key: "/officialweb/admin/articleManagement",
    //                 label: "貼文管理",
    //             },
    //             // {
    //             //     key: "/officialweb/admin/fileManagement",
    //             //     label: "檔案管理",
    //             // },
    //         ],
    //     },
    //     {
    //         label: "社群互動與整合",
    //         children: [
    //             {
    //                 key: "/officialweb/admin/communitySetting",
    //                 label: "網站社群設定",
    //             },
    //             {
    //                 key: "/officialweb/admin/appointment",
    //                 label: "網站諮詢管理",
    //             },
    //         ],
    //     },

    // ];
    const needReload = useRef(false)
    const { StaffDivergeSelfData, getStaffDivergeSelfData } = useStaffDivergeSelf({})
    const backendMenuData = [
        // {
        //     key: "/library/online_public_catalog_query_construction",
        //     label: "館藏查詢",
        // },
        // {
        //     key: "/officialweb/frontend",
        //     label: "圖書入口網",
        // },
        // {
        //     key: "/library/backstage",
        //     label: "後台資訊總覽",
        // },
        // ...(StaffDivergeSelfData?.find(_ => true)?.permission_data || []).map(item => {
        //     return {
        //         label: item?.permission_group_name,
        //         children: item?.permission_data?.map(itemItem => (
        //             {
        //                 label: itemItem?.permission_name,
        //                 key: itemItem?.url,
        //             }
        //         ))
        //     }
        // }),

        // 用 flatMap 來攤平後續資料
        ...(StaffDivergeSelfData?.find(_ => true)?.permission_data || []).flatMap(item => {
            // 如果是 default 群組，就把 permission_data 裡的每一項攤平
            if (item?.permission_group_name === 'default') {
                return item?.permission_data?.map(itemItem => ({
                    key: itemItem?.url,
                    label: itemItem?.permission_name
                })) || [];
            }
            // 否則就回傳一個帶 children 的物件
            return [{
                label: item?.permission_group_name,
                children: item?.permission_data?.map(itemItem => ({
                    key: itemItem?.url,
                    label: itemItem?.permission_name
                })) || []
            }];
        })
    ]
    const { ResponseData, getData, postData, patchData, deleteData } =
        useCRUDController({
            apiRoute: "/dynamicWebsite/frontend/menu",
        });

    // treeData轉換為route
    const generateRoutes = (nodes, parentPath = "") => {
        return nodes.flatMap((node) => {

            // 移除 node.path 前缀的/
            const currentPath = `${parentPath}/${node?.permission_id}`
                .replace(/\/$/, "")
                .replace(/^\//, "");

            // 子Route
            const route = {
                path: currentPath || "/",
                element: (
                    <MainPage prefixTitle={prefixTitle} title={node?.name} permissionId={node?.permission_id} />
                ),
                children: node.children
                    ? generateRoutes(node.children, currentPath)
                    : [],
            };

            // 回傳當前route及子route
            return [route, ...route.children];
        });
    };

    // treeData轉換成menu格式
    const generateMenu = (nodes, parentPath = "") => {

        let result = [];
        nodes.forEach((node) => {
            const currentPath = `${parentPath}/${node.permission_id}`.replace(/\/$/, "");
            if (node?.path_check === 0) {
                result.push({
                    label: node?.name,
                    key: `/officialweb/frontend${currentPath}`,
                    path_check: node?.path_check,
                    children: node?.children ? generateMenu(node.children, currentPath) : [],
                });
            }
            else {
                result.push({
                    label: node?.name,
                    key: node?.path,
                    path_check: node?.path_check,
                    children: node?.children ? generateMenu(node.children, currentPath) : [],
                });
            }

        });
        return result;
    };

    const location = useLocation()
    const [userPermissionData, setUserPermissionData] = useState(null)
    const getStaffDiverge = () => {
        const access_token = localStorage.getItem("access_token");
        axios
            .get('/organization_structure/api/staff_diverge_self', {
                headers: {
                    authorization: `Bearer ${access_token}`,
                }
            })
            .then((response) => {
                let data = response.data?.data || []
                let first_data = data.find(ele => true)
                setUserPermissionData(first_data?.user_permission_data)
            })
            .finally(() => {
            })
    }

    const HasPermission = ({ locationPathname, permissions }) => {
        let hasPermission = permissions.find((element) => {
            const regex = new RegExp(`^${element?.permission_url}(\/\\d+)?$`);

            const isMatch = regex.test(locationPathname);
            return isMatch
        })

        if (!hasPermission
            && String(locationPathname).toLowerCase() !== "/"
            && String(locationPathname).toLowerCase() != String('/officialweb/admin/organization_structure/depth').toLowerCase()
            && String(locationPathname).toLowerCase().indexOf('/officialweb/frontend') === -1
            && String(locationPathname).toLowerCase() != '/officialweb/admin'
            && String(locationPathname).toLowerCase() != String('/officialweb/admin/routeSetting').toLowerCase()
            && String(locationPathname).toLowerCase() != String('/officialweb/admin/organization_structure/noPermission').toLowerCase()
        ) {
            navigate('/officialweb/admin/organization_structure/noPermission')
        }
    }

    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
    }, [userPermissionData])
    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
        if (needReload.current === true) {
            getStaffDiverge()
            getStaffDivergeSelfData()
        }
        if (location?.pathname === "/officialweb/admin/organization_structure/permission_management") {
            needReload.current = true
        }
        else {
            needReload.current = false
        }

    }, [location])
    //設定index route
    useEffect(() => {
        if (dynamicRoutes.length > 0) {
            console.log(dynamicRoutes);

            setFirstDynamicRoute(dynamicRoutes[0]);
        }
    }, [dynamicRoutes]);
    useEffect(() => {
        if (treeData.length > 0) {
            setDynamicRoutes(generateRoutes(treeData, ""));
        }
    }, [treeData]);
    useEffect(() => {
        if (ResponseData?.find(_ => true)?.menu_permission_data) {
            console.log(ResponseData?.find(_ => true)?.menu_permission_data);
            setTreeData(ResponseData?.find(_ => true)?.menu_permission_data);
        }
    }, [ResponseData]);
    useEffect(() => {
        getData({
            major: 1
        });
        getStaffDiverge()
        getStaffDivergeSelfData()
    }, []);

    return (
        <>
            <Routes>
                <Route
                    path="frontend"
                    element={<BackgroundProvider>
                        <ComponentLayout admin={admin} menuData={generateMenu(treeData)} /></BackgroundProvider>}
                >
                    <Route
                        index
                        element={<HomePage prefixTitle={prefixTitle} />}
                    />
                    {/* {firstDynamicRoute && (
                        <Route index element={firstDynamicRoute.element} />
                    )} */}
                    {dynamicRoutes.map((route, index) => (
                        <Route key={index} path={route.path} element={route.element}>
                            {route.children &&
                                route.children.map((childRoute, childIndex) => (
                                    <Route
                                        key={childIndex}
                                        path={childRoute.path}
                                        element={childRoute.element}
                                    />
                                ))}
                        </Route>
                    ))}

                    <Route
                        path="moreContent/:blogId"
                        element={<MoreContent prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path="appointment"
                        element={<Appointment prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path="question_and_answer"
                        element={<QuestionAndAnswerAccordion prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path={"previewPage"}
                        element={<PreviewPage prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path={"form_download"}
                        element={<FormDownload prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path={"home_page"}
                        element={<HomePage prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path={"news"}
                        element={<News prefixTitle={prefixTitle} />}
                    />
                    <Route
                        path={"new"}
                        element={<New prefixTitle={prefixTitle} />}
                    />
                </Route>
            </Routes>
            <Routes>
                {admin && (
                    // <>
                    <Route path={""} element={<JWT />}>
                        <Route
                            path={"admin"}
                            element={<NavBarBackend prefixTitle={prefixTitle} menuData={backendMenuData} />}
                        >
                            <Route path="" element={<Mainlayout breadCrumbMode={false} />}>

                                <Route
                                    index
                                    element={<ProtalMainPage prefixTitle={prefixTitle} />}
                                />
                                {/* <Route index element={<Management prefixTitle={prefixTitle} />} /> */}
                                {/* 網站地圖與流量統計模組 */}
                                <Route
                                    path={"systemInformationSetting"}
                                    element={<SystemInformationSetting prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "systemInformationSetting")?.permission_level_id ?? null} />}
                                />
                                <Route
                                    path={"management"}
                                    element={<Management prefixTitle={prefixTitle} />}
                                />
                                <Route
                                    path={"routeSetting"}
                                    // element={<RouteSetting key={'all'} prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "routeSetting")?.permission_level_id ?? null} />}
                                    element={<RouteSetting key={'all'} prefixTitle={prefixTitle} permission_level={1} />}
                                />
                                <Route
                                    path={"routeSettingSelf"}
                                    element={<RouteSetting key={'self'} prefixTitle={prefixTitle} self={true} />}
                                />
                                {/* 網站主題風格設定 */}
                                <Route
                                    path={"templateManagement"}
                                    element={<TemplateManagement prefixTitle={prefixTitle} />}
                                />

                                {/* 客製化頁面編排與檔案管理模組 */}
                                <Route
                                    path={"pageSetting"}
                                    element={<PageManagement key={'all'} prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "pageSetting")?.permission_level_id ?? null} />}
                                />
                                <Route
                                    path={"pageSettingSelf"}
                                    element={<PageManagement key={'self'} prefixTitle={prefixTitle} self={true} />}
                                />
                                <Route
                                    path={"pageSetting/:page_id"}
                                    element={<PageSetting prefixTitle={prefixTitle} />}
                                />
                                <Route
                                    path={"pageSettingSelf/:page_id"}
                                    element={<PageSetting prefixTitle={prefixTitle} />}
                                />
                                <Route
                                    path={"articleManagement"}
                                    element={<ArticleManagement prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "articleManagement")?.permission_level_id ?? null} />}
                                />
                                <Route
                                    path={"blogCategoryManagement"}
                                    element={<BlogCategory prefixTitle={prefixTitle} />}
                                />
                                <Route
                                    path={"fileManagement"}
                                    element={<ArticleManagement prefixTitle={prefixTitle} />}
                                />
                                {/* 社群互動與整合 */}
                                <Route
                                    path={"communitySetting"}
                                    element={<CommunitySetting prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "communitySetting")?.permission_level_id ?? null} />}
                                />

                                <Route
                                    path={"appointment"}
                                    element={<AppointmentManagement prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "appointment")?.permission_level_id ?? null} />}
                                />
                                <Route
                                    path={"menuSetting"}
                                    element={<MenuSetting key={'all'} prefixTitle={prefixTitle} permission_level={userPermissionData?.find(item => item?.permission_url.split("/").pop() === "menuSetting")?.permission_level_id ?? null} />}
                                />
                                <Route
                                    path={"menuSettingSelf"}
                                    element={<MenuSetting key={'self'} prefixTitle={prefixTitle} self={true} />}
                                />
                                {/* <Route path={'StreamingManagement'} element={<StreamingManagement prefixTitle={prefixTitle}/>} /> */}
                                <Route
                                    path={"audio_recorder/liveAdmin/:RoomId"}
                                    element={<Live prefixTitle={prefixTitle} admin={true} />}
                                />
                                <Route path={"news/*"} element={<MainRouteNews />} />
                                <Route path={'organization_structure/*'} element={<RouteOrganizationStructure user_permission={userPermissionData ?? null} />}>
                                </Route>

                                <Route
                                    path={"TabsCard"}
                                    element={
                                        <>
                                            <TabsCard
                                                TabsData={[
                                                    {
                                                        TabsTitle: 'Overview',
                                                        TabsContent: (
                                                            <div className='text-center'>
                                                                <h3 className="text-lg font-bold">公司概覽</h3>
                                                                <p>這是一個關於公司的簡短介紹，包括使命和願景。</p>
                                                                <div className="flex gap-4 mt-2 justify-center">
                                                                    <img src="https://via.placeholder.com/150" alt="Company Logo" className="w-auto" />
                                                                </div>
                                                                <p className="mt-2">更多關於我們的資訊，請訪問我們的官網。</p>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'Products',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">產品列表</h3>
                                                                <p>我們提供以下產品：</p>
                                                                <ul className="list-disc pl-5 mt-2">
                                                                    <li>產品 A</li>
                                                                    <li>產品 B</li>
                                                                    <li>產品 C</li>
                                                                </ul>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'Services',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">服務內容</h3>
                                                                <p>我們提供專業的服務，包括：</p>
                                                                <ul className="list-disc pl-5 mt-2">
                                                                    <li>服務一</li>
                                                                    <li>服務二</li>
                                                                    <li>服務三</li>
                                                                </ul>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'Contact Us',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">聯絡我們</h3>
                                                                <p>您可以通過以下方式聯繫我們：</p>
                                                                <p>Email: contact@example.com</p>
                                                                <p>Phone: +123 456 7890</p>
                                                            </div>
                                                        ),
                                                    }
                                                ]}
                                            />
                                            <br />
                                            <br />
                                            <TabsCard
                                                TabsData={[
                                                    {
                                                        TabsTitle: 'Introduction',
                                                        TabsContent: (
                                                            <div className="text-center">
                                                                <h3 className="text-lg font-bold">歡迎介紹</h3>
                                                                <p>歡迎來到我們的網站！我們致力於提供最優質的服務。</p>
                                                                <img
                                                                    src="https://via.placeholder.com/300x200"
                                                                    alt="Welcome"
                                                                    className="w-auto mt-4 mx-auto"
                                                                />
                                                                <p className="mt-2">感謝您的關注與支持。</p>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'Features',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">產品特色</h3>
                                                                <p>我們的產品具有以下特色：</p>
                                                                <ul className="list-disc pl-5 mt-2">
                                                                    <li>高性能</li>
                                                                    <li>易於使用</li>
                                                                    <li>高度可擴展</li>
                                                                </ul>
                                                                <img
                                                                    src="https://via.placeholder.com/300x200"
                                                                    alt="Features"
                                                                    className="w-auto mt-4 mx-auto"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'Pricing',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">價格方案</h3>
                                                                <p>選擇適合您的價格方案：</p>
                                                                <table className="w-full border-collapse mt-4">
                                                                    <thead>
                                                                        <tr className="bg-gray-100">
                                                                            <th className="border p-2">方案</th>
                                                                            <th className="border p-2">價格</th>
                                                                            <th className="border p-2">功能</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="border p-2">基本版</td>
                                                                            <td className="border p-2">$9.99/月</td>
                                                                            <td className="border p-2">基本功能</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="border p-2">專業版</td>
                                                                            <td className="border p-2">$19.99/月</td>
                                                                            <td className="border p-2">所有功能</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="border p-2">企業版</td>
                                                                            <td className="border p-2">聯絡我們</td>
                                                                            <td className="border p-2">定制功能</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'FAQ',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">常見問題解答</h3>
                                                                <div className="mt-4">
                                                                    <h4 className="font-semibold">問：如何開始使用？</h4>
                                                                    <p>答：您可以先註冊一個免費帳號，然後選擇適合您的方案。</p>
                                                                </div>
                                                                <div className="mt-4">
                                                                    <h4 className="font-semibold">問：是否提供客戶支持？</h4>
                                                                    <p>答：是的，我們提供7x24小時的客戶支持服務。</p>
                                                                </div>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        TabsTitle: 'Testimonials',
                                                        TabsContent: (
                                                            <div>
                                                                <h3 className="text-lg font-bold">客戶評價</h3>
                                                                <div className="mt-4">
                                                                    <p>"這是我用過最好的產品，強烈推薦！" - 客戶A</p>
                                                                </div>
                                                                <div className="mt-4">
                                                                    <p>"客服反應迅速，解決了我的所有問題。" - 客戶B</p>
                                                                </div>
                                                            </div>
                                                        ),
                                                    }
                                                ]}
                                            />
                                        </>
                                    }

                                >

                                </Route>
                                {/* <Route path={'editpage'} element={<Editpage prefixTitle={prefixTitle}/>} /> */}
                                {/* <Route path={'translationTest'} element={<TranslationTest />} /> */}

                                {/* <Route path={'componentSetting'} element={<ComponentSetting />} /> */}
                                {/* <Route path={'componentData'} element={<ComponentData title={"測試"} />} /> */}
                            </Route>
                        </Route>
                    </Route>
                )}
            </Routes>
        </>
    );
};
export default MainRoute;

const JWT = () => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        function (error) {
            const access_token_url = "/access_token";
            const config = error.config;
            let accessRoute = ['/officialweb/admin/routeSetting']
            let pathname = window.location.pathname
            if (error.response?.status === 401 && config.url === access_token_url && !!accessRoute.includes(pathname)) {
                window.location.href = "/login";
                return Promise.reject(error);
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true;
                const refreshToken = localStorage.getItem("refresh_token");
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken,
                    })
                    .then((res) => {
                        if (res?.status === 201) {
                            localStorage.setItem("access_token", res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            };
                            return axios(config);
                        }
                    });
            }
            return Promise.reject(error);
        }
    );
    return <Outlet />;
};
